import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { MOCKUP_IMAGE, purchaseNotifications } from '../data/content';
type Notice = {
  name: string;
  place: string;
  minutes: number;
};
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const indexRef = useRef(0);
  useEffect(() => {
    let hideTimer: number;
    let loopTimer: number;
    const show = () => {
      const item = purchaseNotifications[indexRef.current % purchaseNotifications.length];
      indexRef.current += 1;
      setNotice({
        ...item,
        minutes: Math.floor(Math.random() * 9) + 1
      });
      hideTimer = window.setTimeout(() => setNotice(null), 6000);
      loopTimer = window.setTimeout(show, 6000 + Math.floor(Math.random() * 9000) + 6000);
    };
    const start = window.setTimeout(show, 7000);
    return () => {
      window.clearTimeout(start);
      window.clearTimeout(hideTimer);
      window.clearTimeout(loopTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-36" data-mp="163wcgqrtry1s">
      {notice && <motion.div initial={{
      opacity: 0,
      x: -24,
      y: 8
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -24
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 28
    }} className="fixed bottom-24 left-3 right-3 z-30 sm:right-auto sm:w-[340px]" role="status" aria-live="polite" data-id="element-37" data-mp="117o4pyfyj74n">
          <div className="flex items-center gap-3 rounded-2xl border border-navy/10 bg-white p-2.5 pr-8 shadow-xl" data-id="element-38" data-mp="i81v5guq0cz9">
            <img src={MOCKUP_IMAGE} alt="" className="h-12 w-12 shrink-0 rounded-lg bg-navy/5 object-contain p-1" data-id="element-39" data-mp="x5u7k04z0l98" />
            <div className="min-w-0" data-id="element-40" data-mp="s8kk2q156jo1">
              <p className="truncate text-[13px] font-extrabold text-navy" data-id="element-41" data-mp="28joiy3suf4im">{notice.name}</p>
              <p className="text-[11px] leading-tight text-navy/60" data-id="element-42" data-mp="23lwk0pts6i4x">
                compró Ruta Anticoagulación™ desde{' '}
                <span className="font-semibold text-navy/80" data-id="element-43" data-mp="2anrwp97xpgjj">{notice.place}</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[10px] font-semibold text-emerald-600" data-id="element-44" data-mp="2fmcuz33mlq5c">
                <CheckCircle2Icon className="h-3 w-3" data-id="element-45" data-mp="2knaepk4aas8y" />
                Compra verificada · hace {notice.minutes} min
              </p>
            </div>
            <button type="button" onClick={() => setNotice(null)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded-full p-1 text-navy/30 transition-colors hover:text-navy" data-id="element-46" data-mp="1rybvejofdk22">
              <XIcon className="h-3.5 w-3.5" data-id="element-47" data-mp="21u6j3t7ia5bp" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}